import ReactTimeAgo from "components/TimeAgo"

// note?.scheduledAt
export function TimeFromNowText({ unixTimeMS }: { unixTimeMS: number }) {
  const scheduledForMoreThanOneDayAway =
    new Date(unixTimeMS).getTime() - new Date().getTime() > 86400000

  return (
    <span className="ml-1">
      <ReactTimeAgo
        date={unixTimeMS}
        locale="en-US"
        // className="ml-1"
      />
      {scheduledForMoreThanOneDayAway && (
        <span>{` at ${new Date(unixTimeMS).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}`}</span>
      )}
    </span>
  )
}
